import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AdminApp from './admin/AdminApp'
import ShareView from './components/ShareView'
import { captureAttribution } from './lib/attribution'
import './index.css'

// Capture utm/referrer/gclid before anything can mutate the URL or navigate.
captureAttribution()

const path = window.location.pathname.replace(/\/+$/, '')
const isAdmin = path === '/tdee/admin'
// Legacy random tokens (Y3SKB58P) and 2026-06 profile slugs (m-5ft10-176lb-6k-0604).
const isShare = /\/share\/[A-Za-z0-9-]{6,32}$/.test(path)
// GLP-1 SEO landing page — English (/tdee/glp1-calculator) and Spanish
// (/tdee/es/glp1-calculator). Same App + TDEE engine + handoff funnel, booted
// into the GLP-1 default experience; the Spanish variant additionally boots
// Spanish via useLang() (path prefix). The crawler-facing prerendered shell +
// schema are served by the worker (server/src/glp1-html.ts).
const isGlp1 = /\/glp1-calculator$/.test(path)
// Embeddable widget (/tdee/embed): the same calculator engine with the site
// chrome (nav/hero/footer/disclaimer) and the SMS/plan funnel stripped, sized
// to run inside a third-party iframe. Third-party sites drop in the iframe +
// a visible dofollow attribution link (see seo/embed-widget.md) — the iframe
// is the tool, the link is what actually passes SEO value.
const isEmbed = /\/embed$/.test(path)

function pickRoot() {
  if (isAdmin) return <AdminApp />
  if (isShare) return <ShareView />
  if (isEmbed) return <App embed />
  return <App glp1={isGlp1} />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{pickRoot()}</React.StrictMode>
)
